export default __webpack_public_path__ + "static/media/close-cross.e4e5d624.svg";